import constants from '../shared/constants';

document.addEventListener('DOMContentLoaded', (): void => {
    const menuElement = document.getElementById(constants.targets.menu.main);
    const navbarBurger = document.getElementById(constants.targets.menu.burger);
    const documentElement = document.documentElement;

    if (navbarBurger && menuElement) {
        const drillLinks = Array.from(menuElement.querySelectorAll<HTMLElement>(constants.targets.menu.drilldownLink));
        const backLinks = Array.from(menuElement.querySelectorAll<HTMLElement>(constants.targets.menu.backLink));

        const burgerLabel = navbarBurger.querySelector<HTMLElement>(constants.targets.menu.burgerLabel);
        if (!burgerLabel) return;

        const setMenuState = (isOpen: boolean): void => {
            navbarBurger.classList.toggle(constants.classes.active, isOpen);
            menuElement.classList.toggle(constants.classes.active, isOpen);
            documentElement.classList.toggle(constants.classes.menuOpen, isOpen);
            burgerLabel.innerHTML = isOpen ? navbarBurger.dataset.closeText ?? '' : navbarBurger.dataset.menuText ?? '';
        };

        navbarBurger.addEventListener('click', (): void => {
            setMenuState(!navbarBurger.classList.contains(constants.classes.active));
        });

        document.addEventListener('click', (event: MouseEvent): void => {
            const target = event.target as Node;
            const isClickInside = menuElement.contains(target) || navbarBurger.contains(target);

            if (!isClickInside) {
                setMenuState(false);
            }
        });

        window.addEventListener('resize', (): void => {
            if (window.innerWidth >= constants.breakpoints.desktop) {
                setMenuState(false);
            }
        });

        drillLinks.forEach((drillLink) => {
            drillLink.addEventListener('click', (): void => {
                const targetMenu = drillLink.nextElementSibling as HTMLElement | null;
                targetMenu?.classList.add(constants.classes.active);
            }, false);
        });

        backLinks.forEach((backLink) => {
            backLink.addEventListener('click', (event: MouseEvent): void => {
                const targetMenu = (event.target as HTMLElement).closest<HTMLElement>(constants.targets.menu.child);
                targetMenu?.classList.remove(constants.classes.active);
            }, false);
        });
    }
});
